import { render, staticRenderFns } from "./TransferRequestRowActions.vue?vue&type=template&id=212e3698&scoped=true&"
import script from "./TransferRequestRowActions.vue?vue&type=script&lang=js&"
export * from "./TransferRequestRowActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212e3698",
  null
  
)

export default component.exports